import styled from 'styled-components';
import { CarouselHeaderMixin } from '../../mixins/components/CarouselHeaderMixin';
export var StyledCarouselHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCarouselHeader",
  componentId: "c11n-8-107-0__sc-cjyas6-0"
})(["", ""], CarouselHeaderMixin);